import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import * as recruitmentApi from "../../../../core/data/redux/services/recruitmentApi";
import JobDetailsView from "../components/job/JobDetailsView";
import ApplySidebar from "../components/job/ApplySidebar";
import CareerNavbar from "../components/common/CareerNavbar";
import GuestAuthModal from "../components/common/GuestAuthModal";
import CareerFooter from "../components/common/CareerFooter";
import { PublicCareerSettings } from "../types";
import { notify } from "../../../../services/toast.config";

const JobDetailsApply: React.FC = () => {
  const { career_page_uuid, jobId } = useParams<{ career_page_uuid: string; jobId: string }>();
  const navigate = useNavigate();

  const [job, setJob] = useState<any>(null);
  const [settings, setSettings] = useState<PublicCareerSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [guestToken, setGuestToken] = useState<string | null>(localStorage.getItem("guest_token"));

  const primaryColor = settings?.primary_color || "#4f46e5";

  useEffect(() => {
    if (jobId && career_page_uuid) loadData(jobId, career_page_uuid);
  }, [jobId, career_page_uuid]);

  const loadData = async (jId: string, uuid: string) => {
    setLoading(true);
    try {
      const [jobData, pageData] = await Promise.all([
        recruitmentApi.getPublicJobDetails(jId),
        recruitmentApi.getPublicCareerPageByUuid(uuid),
      ]);
      setJob(jobData);
      if (pageData?.settings) {
        setSettings(pageData.settings);
        
        localStorage.setItem("company_id", pageData.settings.company_id);
        localStorage.setItem("company_type", pageData.settings.company_type);
      }
    } catch (err: any) {
      notify.error(err?.data?.error?.message || err?.data?.message || err?.message || "Failed to load job details");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("guest_token");
    setGuestToken(null);
    notify.success("Logged out successfully");
  };

  if (loading) {
    return (
      <div style={{
        display: "flex", justifyContent: "center", alignItems: "center",
        minHeight: "100vh", background: "#f4f5f7",
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!job) {
    return (
      <div style={{
        display: "flex", flexDirection: "column", justifyContent: "center",
        alignItems: "center", minHeight: "100vh",
        background: "#f4f5f7", gap: 16, textAlign: "center",
      }}>
        <i className="ti ti-briefcase-off" style={{ fontSize: 60, color: "#d1d5db" }} />
        <h4 style={{ fontWeight: 700, color: "#111827", margin: 0 }}>Job not found</h4>
        <p style={{ color: "#6b7280", fontSize: 14, margin: 0 }}>
          This job may have been closed or removed.
        </p>
        <Link
          to={`/careers/${career_page_uuid}`}
          style={{
            padding: "10px 24px", borderRadius: 8,
            background: primaryColor, color: "#fff",
            textDecoration: "none", fontWeight: 600, fontSize: 14,
          }}
        >
          Browse All Jobs
        </Link>
      </div>
    );
  }

  const companyInfo = settings
    ? { company_id: String(settings.company_id), company_type: settings.company_type }
    : null;

  return (
    <div style={{ background: "#f4f5f7", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>

      
      <CareerNavbar
        settings={settings}
        guestToken={guestToken}
        onLoginClick={() => setShowAuthModal(true)}
        onLogoutClick={handleLogout}
      />

      
      

      
      <div style={{ margin: "0 auto", padding: "32px 40px" }}>
        <div className="row g-4">

          
          <JobDetailsView
            job={job}
            primaryColor={primaryColor}
            careerPageUuid={career_page_uuid}
          />

          
          <div className="col-lg-4">
            {companyInfo ? (
              <ApplySidebar
                jobId={jobId!}
                job={job}
                companyInfo={companyInfo}
                careerPageUuid={career_page_uuid!}
                primaryColor={primaryColor}
              />
            ) : (
              <div style={{
                background: "#fff", borderRadius: 14,
                border: "1px solid #e8eaed",
                padding: 28, textAlign: "center",
              }}>
                <Spin size="small" />
              </div>
            )}
          </div>
        </div>
      </div>

      <CareerFooter settings={settings} />

      
      {settings?.company_id && (
        <GuestAuthModal
          show={showAuthModal}
          onHide={() => setShowAuthModal(false)}
          companyId={String(settings.company_id)}
          companyType={settings.company_type}
          onSuccess={(token) => {
            setGuestToken(token);
            setShowAuthModal(false);
          }}
        />
      )}
    </div>
  );
};

export default JobDetailsApply;
